import Http from "./http";

export const addNotificationsAPI = (data) => {
    return Http.post("admin/createNotification", data);
};
